var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c("div", { staticClass: "form_title" }, [_vm._v("基本信息")]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "关联客户" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["custName"],
                            expression: "['custName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "线索来源" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["clueSourceName"],
                            expression: "['clueSourceName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "下次跟进时间" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["nextCallonDate"],
                            expression: "['nextCallonDate']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "负责人" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["clueUserName"],
                            expression: "['clueUserName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "form_title" }, [_vm._v("客户工况")]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "运输路线" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["transportRoute"],
                            expression: "['transportRoute']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "运输路况" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["transportConditionName"],
                            expression: "['transportConditionName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "运输距离" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["transportDist"],
                            expression: "['transportDist']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "运输区域地势" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["transportTerrainName"],
                            expression: "['transportTerrainName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "运输货物类型" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["transportGoodsTypeName"],
                            expression: "['transportGoodsTypeName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "form_title" }, [_vm._v("意向信息")]),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "意向等级" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["wantLevelName"],
                            expression: "['wantLevelName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "意向品系" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["strainName"],
                            expression: "['strainName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "意向品牌" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["wantBrandName"],
                            expression: "['wantBrandName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "预购数量" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["wantCount"],
                            expression: "['wantCount']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "预计购车日期" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["estimateBuyDate"],
                            expression: "['estimateBuyDate']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "客户关注点" } },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["customerAttentionName"],
                            expression: "['customerAttentionName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isFail
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "form_title" }, [
                    _vm._v("战败信息"),
                  ]),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "流失车型代码" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["lostModel"],
                                    expression: "['lostModel']",
                                  },
                                ],
                                attrs: { disabled: true },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "流失数量" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["lostNum"],
                                    expression: "['lostNum']",
                                  },
                                ],
                                attrs: { disabled: true },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "改进建议" } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["suggessImprove"],
                                    expression: "['suggessImprove']",
                                  },
                                ],
                                attrs: { disabled: true },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-tabs",
        [
          _c(
            "a-tab-pane",
            { key: "1", attrs: { tab: "线索跟进记录", forceRender: true } },
            [_c("clueProp", { ref: "clueProp", attrs: { rowId: _vm.rowId } })],
            1
          ),
          _c(
            "a-tab-pane",
            { key: "2", attrs: { tab: "合同文件", forceRender: true } },
            [
              _vm.originalPictureUrl || _vm.scanningCopyUrl
                ? _c("div", { staticClass: "contract_img fix" }, [
                    _vm.scanningCopyUrl
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.scanningCopyUrl,
                              target: "_blank",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "l",
                              attrs: { src: _vm.scanningCopyUrl, alt: "" },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm.originalPictureUrl
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.originalPictureUrl,
                              target: "_blank",
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "l",
                              attrs: { src: _vm.originalPictureUrl, alt: "" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "a-tab-pane",
            { key: "3", attrs: { tab: "战败原因", forceRender: true } },
            [_c("failReason", { ref: "failReason" })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }